import Wrapper from '@app/Wrapper.js'

Munio.UserManager = class extends Wrapper {
  constructor(selection) {
    super(selection)
  }

  component() {
    return import('./App.vue')
  }
}
